import { render, staticRenderFns } from "./modalNews.vue?vue&type=template&id=41d7d7ce&scoped=true&"
import script from "./modalNews.vue?vue&type=script&lang=js&"
export * from "./modalNews.vue?vue&type=script&lang=js&"
import style0 from "./modalNews.vue?vue&type=style&index=0&id=41d7d7ce&scoped=true&lang=css&"
import style1 from "./modalNews.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7d7ce",
  null
  
)

export default component.exports